import { Button, Card, CardBody, Col, Container, Row, Table } from "reactstrap";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { confirm } from "components/Confirmation";
import { alert } from "components/Alert";

import contratoService from "services/ContratoService";

import Item from "./Item";

import { erroInesperado, totalizar } from "services/Utils";
import TitleFormWithEdit from "components/TitleFormWithEdit";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { formatDate } from "services/Utils";
import { formatNumber } from "services/Utils";
import styled from "styled-components";
import { extrairItensArvore } from "services/Utils";

import '../index.scss'

const paiRoot = {
  id: null,
  descricao: 'Grupo Principal'
}

const Label = styled.div`
  font-weight: 400;
  font-size: 80%;
`

// const Value = styled.div`
//   background-color: #f2f2f2;
//   padding: 5px 10px;
//   border-radius: 5px;
// `

const Value = ({ children }) => <div className="form-control disabled">{children}</div>

export default function NovoAditivoPasso2() {
  const [itens, setItens] = useState([])
  const [alteracoes, setAlteracoes] = useState([])
  const [selecionados, setSelecionados] = useState([])
  const params = useParams()
  const navigate = useNavigate()
  const location = useLocation()

  const idContrato = parseInt(params.idContrato)

  const carregar = async () => {
    if (idContrato) {
      contratoService.getItems(idContrato).then(res => {
        if (res.success) {
          setItens(res.data)

          if (location.state.tipo == 'R') {
            const itens = extrairItensArvore({ filhos: res.data })
            setAlteracoes(itens.map(el => ({ id: el.id, novoPrecoUnitario: el.precoUnitario * (1 + (location.state.percentual / 100)) })))
            setSelecionados(itens.map(el => el.id))
          }
        }
      })
    }
  }

  useEffect(() => {
    carregar()
  }, [idContrato])

  const handleChangePrecoUnitario = (id, novoPrecoUnitario) => {
    const _alteracoes = [...alteracoes]
    let item = _alteracoes.find(el => el.id == id)
    if (!item) {
      item = { id, novoPrecoUnitario }
      _alteracoes.push(item)
    } else {
      item.novoPrecoUnitario = novoPrecoUnitario
    }
    setAlteracoes(_alteracoes)
  }

  const handleChangeQuantidade = (id, novaQuantidade) => {
    const _alteracoes = [...alteracoes]
    let item = _alteracoes.find(el => el.id == id)
    if (!item) {
      item = { id, novaQuantidade }
      _alteracoes.push(item)
    } else {
      item.novaQuantidade = novaQuantidade
    }
    setAlteracoes(_alteracoes)
  }

  const handleChangeSelecao = (id, selecionar) => {
    const _selecionados = [...selecionados]
    if (selecionar) {
      if (!_selecionados.includes(id)) {
        _selecionados.push(id)
        setSelecionados(_selecionados)
      }
    } else {
      setAlteracoes(alteracoes.filter(el => el.id != id))
      setSelecionados(_selecionados.filter(s => s != id))
    }
  }

  const handleSalvar = async () => {
    const alteracoesEnviar = alteracoes.filter(el => !!el.novaQuantidade || !!el.novoPrecoUnitario) // apenas os registros com valor

    if (alteracoesEnviar.length == 0) {
      alert({
        header: 'Atenção',
        text: 'Nenhum item foi alterado'
      })
      return
    }

    try {
      await contratoService.criarAditivo(idContrato, { ...location.state, alteracoes: alteracoesEnviar })
      toast('Registro salvo com sucesso!')
      navigate('/admin/contratos/' + idContrato + '?aba=aditivos')
    } catch (ex) {
      erroInesperado()
    }
  }

  return (
    <Container fluid className="aditivo-items">
      <TitleFormWithEdit title="Criar Aditivo - Itens" showButton={false} />
      <Card className="mb-4">
        <CardBody>
          <Row className="mb-2">
            <Col xs={2}>
              <Label>Número:</Label>
              <Value>{location.state.numero}</Value>
            </Col>
            <Col xs={2}>
              <Label>Início de Vigência:</Label>
              <Value>{formatDate(location.state.inicioVigencia)}</Value>
            </Col>
            <Col xs={2}>
              <Label>Tipo:</Label>
              <Value>{location.state.tipo == 'R' ? 'Reajuste' : 'Ajuste Manual'}</Value>
            </Col>
            {location.state.tipo == 'R' && (
              <Col xs={3}>
                <Label>Percentual inicial aplicado em todos os itens:</Label>
                <Value>{formatNumber(location.state.percentual)}</Value>
              </Col>
            )}
          </Row>
          <Row className="mb-2">
            <Col>
              <Label>Descrição:</Label>
              <Value>{location.state.descricao}</Value>
            </Col>
          </Row>
        </CardBody>
      </Card>
      <Card>
        <CardBody>
          <div className="text-right mb-2">
            <Button color="primary" type="button" onClick={handleSalvar}>Salvar</Button>
          </div>
          <div className="aditivo-table-scroll">
            <Table className="align-items-center table-flush aditivo-wide-table">
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Descrição</th>
                  <th>Unid</th>
                  <th className="text-right">Valor Unit.</th>
                  <th className="text-right">Quantidade</th>
                  <th className="text-right">Valor Total</th>
                  <th className="text-right">Novo Valor Unit.</th>
                  <th className="text-right">Nova Quantidade</th>
                  <th className="text-right">Novo Valor Total</th>
                  <th style={{ width: 120 }}></th>
                </tr>
              </thead>
              <tbody>
                {itens.map(el => (
                  <Item
                    alteracoes={alteracoes}
                    selecionados={selecionados}
                    key={el.id}
                    {...el}
                    onChangePrecoUnitario={handleChangePrecoUnitario}
                    onChangeQuantidade={handleChangeQuantidade}
                    onChangeSelecao={handleChangeSelecao}
                  />
                ))}
              </tbody>
            </Table>
          </div>
          <div className="text-right mt-2">
            <Button color="primary" type="button" onClick={handleSalvar}>Salvar</Button>
          </div>
        </CardBody>
      </Card>
    </Container>

  )
}
